module.exports = __webpack_public_path__ + "static/media/BtnBanner2.caa0c63e.jpg";